var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeauturedIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#191919"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.3333 23.6667H39.7477C38.9185 23.6667 38.3333 22.8292 38.3333 22C38.3333 19.2386 36.0948 17 33.3333 17C30.5719 17 28.3333 19.2386 28.3333 22C28.3333 22.8292 27.7481 23.6667 26.9189 23.6667H23.3333C22.4129 23.6667 21.6667 24.4129 21.6667 25.3333V28.9189C21.6667 29.7481 20.8292 30.3333 20 30.3333C17.2386 30.3333 15 32.5719 15 35.3333C15 38.0948 17.2386 40.3333 20 40.3333C20.8292 40.3333 21.6667 40.9185 21.6667 41.7477V45.3333C21.6667 46.2538 22.4129 47 23.3333 47L43.3333 47.0001C44.2538 47.0001 45 46.2538 45 45.3333V41.7477C45 40.9185 44.1625 40.3333 43.3333 40.3333C40.5719 40.3333 38.3333 38.0948 38.3333 35.3333C38.3333 32.5719 40.5719 30.3333 43.3333 30.3333C44.1625 30.3333 45 29.7481 45 28.9189L45.0001 25.3333C45.0001 24.4129 44.2538 23.6667 43.3333 23.6667Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeauturedIcon1);
export default __webpack_public_path__ + "static/media/feauturedIcon1.f431a6107ebb610727b095276eae5382.svg";
export { ForwardRef as ReactComponent };